import { render, staticRenderFns } from "./BaseIndivTable.vue?vue&type=template&id=35bb7c92&scoped=true&"
import script from "./BaseIndivTable.vue?vue&type=script&lang=js&"
export * from "./BaseIndivTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseIndivTable.vue?vue&type=style&index=0&id=35bb7c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb7c92",
  null
  
)

export default component.exports